// src/hooks/useActualitesParams.js
import { useState, useEffect, useCallback } from "react";
import { getAuthHeaders } from "../services/api";

const triggerActualitesUpdate = () => {
  window.dispatchEvent(new CustomEvent("actualitesParamsUpdated"));
};

const useActualitesParams = () => {
  console.log("🎯 [HOOK] useActualitesParams initialisé");
  
  const [actualites, setActualites] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const loadActualites = useCallback(async () => {
    console.log("📡 [HOOK] loadActualites appelé");
    console.log("📡 [HOOK] URL:", "/api/parametres/actualites");
    console.log("📡 [HOOK] Token:", localStorage.getItem("token") ? "✅ Présent" : "❌ Absent");
    
    try {
      setLoading(true);
      console.log("⏳ [HOOK] Loading = true");
      
      const response = await fetch("/api/parametres/actualites", {
        method: "GET",
        headers: getAuthHeaders(),
        credentials: "include",
      });

      console.log("📥 [HOOK] Réponse reçue, status:", response.status);
      console.log("📥 [HOOK] Response OK?", response.ok);

      if (!response.ok) {
        throw new Error(`Erreur ${response.status}`);
      }

      const data = await response.json();
      console.log("📦 [HOOK] Données brutes:", data);
      console.log("📦 [HOOK] data.data:", data.data);
      console.log("📦 [HOOK] Nombre d'actualités:", data.data?.length || 0);
      
      setActualites(data.data || []);
      console.log("✅ [HOOK] Actualités définies dans le state");
      setError(null);
      
    } catch (err) {
      console.error("❌ [HOOK] Erreur complète:", err);
      console.error("❌ [HOOK] Message d'erreur:", err.message);
      console.error("❌ [HOOK] Stack:", err.stack);
      setError(err.message);
      setActualites([]);
    } finally {
      setLoading(false);
      console.log("✅ [HOOK] Loading = false");
    }
  }, []);

  const addActualite = async (actuData) => {
    console.log("➕ [HOOK] addActualite appelé avec:", actuData);
    try {
      const response = await fetch("/api/parametres/actualites", {
        method: "POST",
        headers: getAuthHeaders(),
        credentials: "include",
        body: JSON.stringify(actuData),
      });

      console.log("📥 [HOOK] POST Response status:", response.status);

      if (!response.ok) {
        // Le serveur explique pourquoi il refuse : on garde son message plutot
        // qu'un code de statut nu.
        const details = await response.json().catch(() => ({}));
        throw new Error(details.message || details.error || `Erreur ${response.status}`);
      }

      await loadActualites();
      triggerActualitesUpdate();
      console.log("✅ [HOOK] Actualité ajoutée avec succès");
      return { success: true };
    } catch (err) {
      console.error("❌ [HOOK] Erreur ajout:", err);
      return { success: false, error: err.message };
    }
  };

  const updateActualite = async (id, actuData) => {
    console.log("📝 [HOOK] updateActualite appelé pour ID:", id, "avec:", actuData);
    try {
      const response = await fetch(`/api/parametres/actualites/${id}`, {
        method: "PUT",
        headers: getAuthHeaders(),
        credentials: "include",
        body: JSON.stringify(actuData),
      });

      console.log("📥 [HOOK] PUT Response status:", response.status);

      if (!response.ok) {
        // Le serveur explique pourquoi il refuse : on garde son message plutot
        // qu'un code de statut nu.
        const details = await response.json().catch(() => ({}));
        throw new Error(details.message || details.error || `Erreur ${response.status}`);
      }

      await loadActualites();
      triggerActualitesUpdate();
      console.log("✅ [HOOK] Actualité mise à jour avec succès");
      return { success: true };
    } catch (err) {
      console.error("❌ [HOOK] Erreur update:", err);
      return { success: false, error: err.message };
    }
  };

  const deleteActualite = async (id) => {
    console.log("🗑️ [HOOK] deleteActualite appelé pour ID:", id);
    try {
      const response = await fetch(`/api/parametres/actualites/${id}`, {
        method: "DELETE",
        headers: getAuthHeaders(),
        credentials: "include",
      });

      console.log("📥 [HOOK] DELETE Response status:", response.status);

      if (!response.ok) {
        // Le serveur explique pourquoi il refuse : on garde son message plutot
        // qu'un code de statut nu.
        const details = await response.json().catch(() => ({}));
        throw new Error(details.message || details.error || `Erreur ${response.status}`);
      }

      await loadActualites();
      triggerActualitesUpdate();
      console.log("✅ [HOOK] Actualité supprimée avec succès");
      return { success: true };
    } catch (err) {
      console.error("❌ [HOOK] Erreur delete:", err);
      return { success: false, error: err.message };
    }
  };

  useEffect(() => {
    console.log("🔄 [HOOK] useEffect du hook déclenché");
    loadActualites();

    const handleUpdate = () => {
      console.log("🔄 [HOOK] Actualités mises à jour (event)");
      loadActualites();
    };

    window.addEventListener("actualitesParamsUpdated", handleUpdate);
    return () => {
      console.log("🧹 [HOOK] Cleanup du hook");
      window.removeEventListener("actualitesParamsUpdated", handleUpdate);
    };
  }, [loadActualites]);

  console.log("📊 [HOOK] État actuel - actualites:", actualites.length, "loading:", loading, "error:", error);

  return {
    actualites,
    addActualite,
    updateActualite,
    deleteActualite,
    loadActualites,
    loading,
    error,
  };
};

export default useActualitesParams;
